// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"720b4335","453":"4fa34638","455":"20d43be2","977":"56c85665"}[chunkId] + ".chunk.js";
};